import React, { useState, useRef } from 'react';
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';
import HCaptcha from '@hcaptcha/react-hcaptcha';

const FreeConsult = () => {
    const { t, i18n } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        topic: '',
        contactMethod: '',
        contactInfo: '',
        consultationTime: '',
        additionalInfo: ''
    });
    const [showSuccess, setShowSuccess] = useState(false);
    const [token, setToken] = useState(null);
    const captchaRef = useRef(null);

    const topics = [
        { value: 'feasibility', label: t('consult.topics.feasibility') },
        { value: 'planning', label: t('consult.topics.planning') },
        { value: 'construction', label: t('consult.topics.construction') },
        { value: 'portfolio', label: t('consult.topics.portfolio') },
        { value: 'custom', label: t('consult.topics.custom') }
    ];

    const contactMethods = [
        { value: 'email', label: t('consult.contact.email') },
        { value: 'phone', label: t('consult.contact.phone') }
    ];

    const onVerify = (token) => {
        setToken(token);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!token) {
            alert(t("contact_form.please_verify_captcha"));
            return;
        }

        // Prepare the email template data
        const templateParams = {
            fullname: formData.name,
            topic: topics.find(t => t.value === formData.topic)?.label || formData.topic,
            consultation_time: formData.consultationTime,
            page_info: window.location.href,
            message: formData.additionalInfo
        };

        // Add contact info based on selected method
        if (formData.contactMethod === 'email') {
            templateParams.email = formData.contactInfo;
            templateParams.phone = '';
        } else {
            templateParams.phone = formData.contactInfo;
            templateParams.email = '';
        }

        emailjs
            .send(
                'service_0qn969g',
                'template_xzim6i9',
                templateParams,
                'PcHzeyHQ7091mGvgC'
            )
            .then((result) => {
                console.log(result.text);
                if (result.text === "OK") {
                    setFormData({
                        name: '',
                        topic: '',
                        contactMethod: '',
                        contactInfo: '',
                        consultationTime: '',
                        additionalInfo: ''
                    });
                    setShowSuccess(true);
                    // Reset captcha after successful submission
                    captchaRef.current.resetCaptcha();
                    setToken(null);

                    // Hide success message after 10 seconds
                    setTimeout(() => {
                        setShowSuccess(false);
                    }, 10000);
                }
            },
            (error) => {
                console.log(error.text);
                alert(t("contact_form.error_message"));
            });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <>
            <SEO title="Free Consultation - Cyberate Investments" />
            <main className="page-wrapper">
                <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

                <div className="main-content page-content-text" style={{ 
                    padding: '100px 0', 
                    backgroundColor: '#000',
                    minHeight: '100vh'
                }}>
                    <div className="container">
                        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                            <h1 style={{ 
                                fontSize: '60px', 
                                color: '#fff', 
                                marginBottom: '20px', 
                                fontWeight: '700',
                                textAlign: 'center'
                            }}>
                                Real Estate Analysis
                            </h1>
                            <p style={{ 
                                color: '#ccc', 
                                fontSize: '18px', 
                                margin: '0 auto', 
                                lineHeight: '1.6', 
                                textAlign: 'center' 
                            }}>
                                {t('consult.subtitle')}
                            </p>
                        </div>

                        <div style={{ 
                            margin: '0 auto', 
                            padding: '40px', 
                            background: '#000', 
                            borderRadius: '12px', 
                            boxShadow: '0 0 20px rgba(0,0,0,0.1)',
                            color: '#fff'
                        }}>
                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: '25px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        color: '#fff', 
                                        fontWeight: '500' 
                                    }}>
                                        <span style={{ color: '#ff0000', marginRight: '4px' }}>*</span>
                                        {t('consult.form.name')}
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        required
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder={t('consult.form.namePlaceholder')}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '0 15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff',
                                            color: '#000'
                                        }}
                                    />
                                </div>

                                <div style={{ marginBottom: '25px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        color: '#fff', 
                                        fontWeight: '500' 
                                    }}>
                                        <span style={{ color: '#ff0000', marginRight: '4px' }}>*</span>
                                        {t('consult.form.topic')}
                                    </label>
                                    <select
                                        name="topic"
                                        required
                                        value={formData.topic}
                                        onChange={handleChange}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '0 15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff',
                                            color: '#000',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <option value="">{t('consult.form.selectPlaceholder')}</option>
                                        {topics.map(topic => (
                                            <option key={topic.value} value={topic.value}>
                                                {topic.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <p style={{ 
                                    color: '#fff', 
                                    fontSize: '16px', 
                                    marginBottom: '12px', 
                                    fontWeight: '500' 
                                }}>
                                    {t('consult.form.contactQuestion')}
                                </p>

                                <div style={{ marginBottom: '25px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        color: '#fff', 
                                        fontWeight: '500' 
                                    }}>
                                        <span style={{ color: '#ff0000', marginRight: '4px' }}>*</span>
                                        {t('consult.form.contactMethod')}
                                    </label>
                                    <select
                                        name="contactMethod"
                                        required
                                        value={formData.contactMethod}
                                        onChange={handleChange}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '0 15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff',
                                            color: '#000',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <option value="">{t('consult.form.selectPlaceholder')}</option>
                                        {contactMethods.map(method => (
                                            <option key={method.value} value={method.value}>
                                                {method.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ marginBottom: '25px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        color: '#fff', 
                                        fontWeight: '500' 
                                    }}>
                                        <span style={{ color: '#ff0000', marginRight: '4px' }}>*</span>
                                        {formData.contactMethod === 'email' 
                                            ? t('consult.form.emailAddress') 
                                            : t('consult.form.phoneNumber')}
                                    </label>
                                    <input
                                        type={formData.contactMethod === 'email' ? 'email' : 'tel'}
                                        name="contactInfo"
                                        required
                                        value={formData.contactInfo}
                                        onChange={handleChange}
                                        placeholder={formData.contactMethod === 'email' 
                                            ? t('consult.form.emailPlaceholder')
                                            : t('consult.form.phonePlaceholder')}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '0 15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff',
                                            color: '#000'
                                        }}
                                    />
                                </div>

                                <div style={{ marginBottom: '25px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        color: '#fff', 
                                        fontWeight: '500' 
                                    }}>
                                        {t('consult.form.additionalInfoTitle')}
                                    </label>
                                    <textarea
                                        name="additionalInfo"
                                        value={formData.additionalInfo}
                                        onChange={handleChange}
                                        placeholder={t('consult.form.additionalInfoPlaceholder')}
                                        style={{
                                            width: '100%',
                                            padding: '15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff',
                                            color: '#000',
                                            minHeight: '150px',
                                            lineHeight: '1.5',
                                            resize: 'vertical'
                                        }}
                                    />
                                </div>

                                <p style={{ 
                                    color: '#fff', 
                                    fontSize: '16px', 
                                    marginBottom: '12px', 
                                    fontWeight: '500' 
                                }}>
                                    {t('consult.form.scheduleQuestion')}
                                </p>

                                <div style={{ marginBottom: '25px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        color: '#fff', 
                                        fontWeight: '500' 
                                    }}>
                                        {t('consult.form.datetime')}
                                    </label>
                                    <input
                                        type="datetime-local"
                                        name="consultationTime"
                                        value={formData.consultationTime}
                                        onChange={handleChange}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            padding: '0 15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '16px',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff',
                                            color: '#000'
                                        }}
                                    />
                                </div>

                                <div style={{ marginBottom: '25px' }}>
                                    <HCaptcha
                                        sitekey="54443e30-488a-495a-abf4-acce12fab18c"
                                        onVerify={onVerify}
                                        ref={captchaRef}
                                    />
                                </div>

                                <p style={{ 
                                    color: '#ccc', 
                                    fontSize: '14px', 
                                    textAlign: 'center', 
                                    margin: '20px 0' 
                                }}>
                                    {t('consult.form.privacy')}
                                </p>

                                {!showSuccess ? (
                                    <button 
                                        type="submit"
                                        style={{
                                            background: 'linear-gradient(90deg, #FFAE2C 0%, #FFD945 100%)',
                                            color: '#000',
                                            padding: '15px 30px',
                                            border: 'none',
                                            borderRadius: '6px',
                                            fontSize: '18px',
                                            cursor: 'pointer',
                                            width: '300px',
                                            fontWeight: '600',
                                            margin: '0 auto',
                                            display: 'block',
                                            transition: 'background-color 0.3s'
                                        }}
                                    >
                                        {t('consult.form.submit')}
                                    </button>
                                ) : (
                                    <div style={{
                                        backgroundColor: '#4CAF50',
                                        color: 'white',
                                        padding: '20px',
                                        borderRadius: '6px',
                                        textAlign: 'center',
                                        width: '300px',
                                        margin: '0 auto',
                                        marginTop: '20px'
                                    }}>
                                        {t('consult.form.success')}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>

                <FooterTwo />
            </main>
        </>
    );
};

export default FreeConsult;
